/**
 * @memberof module:util
 * @function
 * @name isEmpty
 * @description check whether argument obj is empty
 *
 * @param {Object} obj - object to check if it's empty or not
 * @returns {boolean}
 *
 * @example
 * console.log(isEmpty()); //true
 * console.log(isEmpty(null)); //true
 * console.log(isEmpty(undefined)); //true
 * console.log(isEmpty({})); //true
 *
 * console.log(isEmpty("")); //false
 * console.log(isEmpty("hello")); //false
 * console.log(isEmpty(134)); //false
 * console.log(isEmpty({ year: 2021 })); //false
 */

export const isEmpty = (obj) => {
  if (obj === null || obj === undefined) {
    return true;
  }
  return Object.entries(obj).length === 0 && obj.constructor === Object;
};
